module.exports = __webpack_public_path__ + "img/open-mic.71add3a2.png";